<template>
  <div :id="!$route.path.includes('landing') ? 'app' : ''" >


    <div v-if="$root.isLoading" class="loading">
      <div class="loading-box">

        <div class="loading-effect" style="top: 50%;left: 50%;">
          <div class="icon-button" :style="{ 'background-image': 'url(' + logo + ')' }"
            style="height: 3rem;width: auto;">
          </div>
        </div>
        <div class="loading-effect">
          <b-spinner style="width: 5rem; height: 5rem;" label="Large Spinner">

          </b-spinner>

        </div>
        <div class="loading-effect" style="top: 80%;">
          {{ $t('loading...') }}

        </div>
      </div>
    </div>
    <Header></Header>
    <router-view></router-view>
    <Footer></Footer>
    <ModalError></ModalError>
    <!-- <Footer></Footer> -->
    <b-modal id="modal-news" hide-footer hide-header centered>
      <carousel :items="1" v-if="$root.latestNews.length > 0" :nav="false" :autoplay="true" :dots="true"
        :stagePadding="0" :margin="10">

        <div class="mb-4" v-for="item in $root.latestNews" :key="item.id">
          <div class="d-flex justify-content-between align-items-center mb-4">
            <div class="text-20 font-weight-700 text-primary2">{{ item.title }}</div>
            <span class="ml-2 text-20" @click="$bvModal.hide('modal-news')"><i class="fa fa-close"></i></span>

          </div>
          <div class="content">
            <img :src="item.public_path" alt="" width="100%" class="rounded-1">
            <div class="text-left mt-3">
              <div class="text-secondary text-12 mb-2">{{ item.updated_at.split(' ')[0] }}</div>
              <div class="mb-1 text-14 " v-html="item.description.replace(/(\r\n|\r|\n)/g, '<br>')"></div>

            </div>

          </div>

        </div>
      </carousel>
      <div class="checkbox1">
        <b-form-checkbox id="checkbox-1" class="text-14" v-model="checkBoxStatus" name="checkbox-1" :value="true"
          :unchecked-value="false" required>
          {{ $t('dont_show_again_today') }}
        </b-form-checkbox>
      </div>


    </b-modal>



    <!-- <customizer></customizer> -->
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import ModalError from './errorMsg.vue';
import carousel from 'vue-owl-carousel';
import Header from './header.vue';
import Footer from './footer.vue';

export default {
  components: {
    ModalError, carousel, Header, Footer
  },
  watch: {
    $route() {
      var title = this.$route.path.split('/');
      this.title = title[title.length - 1];
      this.path = this.title;

    },
    checkBoxStatus(val) {
      var date = new Date();
      if (val) {
        localStorage.setItem('dunShow', date.getDate());
      } else {

        localStorage.removeItem('dunShow');
      }
    }
  },
  name: 'GVV',
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getThemeMode"]),
    themeName() {
      return this.getThemeMode.dark ? "dark-theme" : " ";
    },
  },
  metaInfo() {
    var title = 'Winato';
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: title.charAt(0).toUpperCase() + title.slice(1),
      // all titles will be injected into this template
      titleTemplate: "%s",
      bodyAttrs: {
        class: [this.themeName, "text-left"]
      },
      htmlAttrs: {
        dir: this.rtl
      },
      meta: [
        { charset: "utf-8" },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
      ],
    };
  }
};
</script>

<style>
#app {
   font-family: 'Lalezar' !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 60px;
}


</style>


